import React from "react";
import bgImage from "../../images/bg/bootcamp-bg.png";
import { Link } from "react-router-dom";

interface PageTitleProps {
  pageTitle: string;
  pagesub?: string;
  /**
   * Heading level for the breadcrumb title. Defaults to "h1" because on most
   * pages this IS the page heading — it used to render <h2>, which left ~19
   * routes (/, /about, /pricing, /faq, /compare, ...) with no <h1> at all once
   * the footer wordmark stopped being one.
   *
   * Pass "h2" from pages that render their own <h1> further down (e.g. comparison
   * and PG pages that repeat the same text in a hero), so they don't ship two <h1> elements.
   */
  headingLevel?: "h1" | "h2";
  description?: React.ReactNode;
  actions?: React.ReactNode;
  badges?: React.ReactNode;
  children?: React.ReactNode;
}


const PageTitle: React.FC<PageTitleProps> = ({
  pageTitle,
  pagesub,
  headingLevel = "h1",
  description,
  actions,
  badges,
  children,
}) => {
  const Heading = headingLevel;
  return (
    <section
      className="breadcrumb bg_img"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="breadcrumb__content">
          <ul className="breadcrumb__list clearfix list-unstyled">
            <li className="breadcrumb-item">
               <Link to="/home">Home</Link>
            </li>
             {pagesub && <li className="breadcrumb-item">{pagesub}</li>}
          </ul>
          {pageTitle && <Heading className="breadcrumb__title">{pageTitle}</Heading>}
          {badges && (
            <div className="breadcrumb__badges d-flex justify-content-center gap-2 flex-wrap mt-20">
              {badges}
            </div>
          )}
          {description && (
            <div
              className="breadcrumb__desc mt-20"
              style={{
                maxWidth: 820,
                margin: "20px auto 0",
                fontSize: "1.12rem",
                lineHeight: 1.7,
                color: "rgba(255, 255, 255, 0.85)",
              }}
            >
              {description}
            </div>
          )}
          {actions && (
            <div className="breadcrumb__actions d-flex justify-content-center align-items-center gap-3 flex-wrap mt-30">
              {actions}
            </div>
          )}
          {children}
        </div>
      </div>
    </section>
  );
};

export default PageTitle;